/* cSpell:disable */
import React from 'react';
import { ErrorTemplateScreen } from '../_errorTemplate';
import { WithCoreProps, TranslationProps } from 'ff-shared-components-core';

export interface NotFoundProps {
	errorMessage?: string;
	errorTitle?: string;
	buttonText?: string;
}

export type NotFoundInjectedProps = TranslationProps;

class NotFoundScreenComponent extends React.Component<NotFoundProps & NotFoundInjectedProps> {
	render(): React.ReactNode {
		const { errorMessage, errorTitle, buttonText } = this.props;

		const title = errorTitle ? errorTitle : 'Erro 404';
		const message = errorMessage ? errorMessage : 'Não conseguimos encontrar a página que procura.';
		const btnText = buttonText ? buttonText : 'Início';

		return <ErrorTemplateScreen errorTitle={title} errorMessage={message} buttonText={btnText} />;
	}
}

export const NotFoundScreen = WithCoreProps<NotFoundProps>(NotFoundScreenComponent);
